import { type VariableValue } from "@doitintl/cmp-models";

interface VariableMaps {
  idToNameMap: Map<string, string>;
  idToValueMap: Map<string, VariableValue["value"]>;
}

export function createVariableMaps(globalVariables?: VariableValue[], localVariables?: VariableValue[]): VariableMaps {
  const idToNameMap = new Map<string, string>();
  const idToValueMap = new Map<string, VariableValue["value"]>();

  globalVariables?.forEach((variable) => {
    idToNameMap.set(variable.id, variable.name);
    idToValueMap.set(variable.id, variable.value);
  });

  localVariables?.forEach((variable) => {
    idToNameMap.set(variable.id, variable.name);
    idToValueMap.set(variable.id, variable.value);
  });

  return { idToNameMap, idToValueMap };
}

export function isVariableReference(referencedField: string[], isTriggerNode: boolean): boolean {
  return (
    isTriggerNode &&
    referencedField.length >= 3 &&
    referencedField[0] === "variables" &&
    (referencedField[1] === "globalVariables" || referencedField[1] === "localVariables")
  );
}

export function getVariableValueFromReferencedField(
  referencedField: string[],
  variableMaps: VariableMaps
): VariableValue["value"] | "" {
  if (referencedField.length >= 3) {
    const variableId = referencedField[2];
    return variableMaps.idToValueMap.get(variableId) || "";
  }
  return "";
}

export function getVariableNameFromReferencedField(referencedField: string[], variableMaps: VariableMaps): string {
  if (referencedField.length >= 3) {
    const variableId = referencedField[2];
    return variableMaps.idToNameMap.get(variableId) || variableId;
  }
  return "";
}
